module.exports = __webpack_public_path__ + "static/1.1.C. OLAR RANDARE 4-e28f2e2070a0c29a391f81bf0196b652.jpg";